<div class="wk-upload-files-list">
  <div
    *ngFor="let eachFile of fileNamesToUpload; let i = index"
    class="upload-list-container"
  >
    <div class="file-name-container">
      <p title="{{ eachFile }}" class="file-name">{{ eachFile }}</p>
      <span
        class="wk-icon-close"
        (click)="deleteFile(i)"
        (keyup)="deleteFile(i)"
      ></span>
    </div>
    <wk-upload-files-dropdown
      [allowedDocTypes]="currentDropDownTypes"
      [file]="files[i]"
      [documentType]="documentType"
      [directoryName]="directoryName"
    ></wk-upload-files-dropdown>
  </div>
</div>
